module.exports = __webpack_public_path__ + "Lato-MediumItalic.aa1a75124661b40a6770.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-MediumItalic.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-MediumItalic.woff
// module chunks = styles